import { Component, Input, ViewEncapsulation, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { element } from 'protractor';

import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
//import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormGroupName} from '@angular/forms';
import { ValidationFormsService } from './validation-forms.service';
import { ValidatorFn, ValidationErrors } from '@angular/forms';
import { ToasterComponent, ToasterPosition } from '@coreui/angular';
import { AppToastComponent as ToastComp } from '../../../services/shared-service/toast-simple/toast.component'
import { HttpService } from '../../../services/http-service/http.service'
import { ModalDirective } from 'ngx-bootstrap/modal';

import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '../../../services/storege-service/storage.service';
import { ToolService } from '../../../services/tool/tool.service';

@Component({
  //selector: 'app-toasters',
  templateUrl: 'basic-forms.component.html',
  styleUrls: ["../../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css",],
  //encapsulation: ViewEncapsulation.None,
  providers: [ ValidationFormsService ]
})


export class BasicFormsComponent {


  minDate = new Date(2017, 5, 10);
  maxDate = new Date(2022, 9, 15);

  bsValue: Date = new Date();

// Timepicker

  public isEnabled: boolean = true;


  public mfData? : object = {};
  public courts?;
  public users?;
  isUpdate: boolean = false;
  dbFunction?: string;
  courtId: string;
  nameEn: string;
  nameAr: string;
  size: string;
  backgroundColor: string;
  price30min: string;
  price60min: string;
  price90min: string;
  price120min: string;
  ccy: string;
  timeSlot: string;
  noOfPlayers: string;
  facilityCcy: string;
  status: string;
  public facilityId = '';
  public isLoading = false;

  isError: boolean = false;

  simpleForm: FormGroup;
  submitted = false;
  formErrors: any;

  //private toasterService: ToasterService;
  //public toasterconfig: ToasterConfig = new ToasterConfig({tapToDismiss: true, timeout: 5000});
  
  @ViewChild(ToastComp) toastComp: ToastComp;
  @ViewChild('dangerModal', {static: false}) public dangerModal: ModalDirective;

  public paddingStyle: Object = { 'padding-right': '20px'};


  constructor(
    private router: Router, 
    private http: HttpClient, 
    public route: ActivatedRoute,
    private fb: FormBuilder,
    public vf: ValidationFormsService, 
    public httpService: HttpService,
    private toastr: ToastrService,
    private localInterfaceSrv: LocalInterfaceService,
    private storageSrv: StorageService,
    public toolService: ToolService,
    ) {
    //if (localStorage.getItem('currentUser') === null) {this.router.navigateByUrl('/login');}
    if (localStorage.getItem('lang') === "ar") {
      //this.toasterconfig = new ToasterConfig({tapToDismiss: true, timeout: 5000, positionClass: 'toast-top-left'});
    }
    //this.toasterService = toasterService;
    this.formErrors = this.vf.errorMessages;
    this.facilityId = this.storageSrv.getFacilityId();
    this.facilityCcy = this.storageSrv.getFacilityCcy();

    if(this.router.getCurrentNavigation().extras.state?.createData == null)
    {
      this.isUpdate = true;
      this.mfData = this.router.getCurrentNavigation().extras.state?.data;
      this.courtId = this.mfData['id'];
      this.nameEn = this.mfData['nameEn'];
      this.nameAr = this.mfData['nameAr'];
      this.size = this.mfData['size'];
      this.noOfPlayers = this.mfData['noOfPlayers'];
      this.backgroundColor = this.mfData['backgroundColor'];
      this.price30min = this.mfData['30minPrice'];
      this.price60min = this.mfData['60minPrice'];
      this.price90min = this.mfData['90minPrice'];
      this.price120min = this.mfData['120minPrice'];
      this.timeSlot = this.mfData['timeSlot'];
      this.ccy = this.mfData['ccy'];
      this.status = this.mfData['status'];
    }
    else
    {
      this.courtId = '';
      this.nameEn = '';
      this.nameAr = '';
      this.size = '';
      this.noOfPlayers = '';
      this.backgroundColor = '';
      this.price30min = '';
      this.price60min = '';
      this.price90min = '';
      this.price120min = '';
      this.timeSlot = '';
      this.ccy = '';
      this.status = '';
    }
    this.createForm();
  }

  isCollapsed: boolean = false;
  iconCollapse: string = 'icon-arrow-up';

  @Input() message : string;
  messages: string[] = [];
  updatedData = this.mfData;

  // Validators.pattern('^[0-9]{4}[\/][1-9]|1[012][\/][0-9]{2}$')]
  createForm() {
    this.simpleForm = this.fb.group({
      courtId: {value: this.courtId, disabled: true },
      nameEn: [this.nameEn, [Validators.required]],
      nameAr: [this.nameAr, [Validators.required]],
      size: [this.size, [Validators.required]],
      noOfPlayers: [this.noOfPlayers, [Validators.required]],
      backgroundColor: [this.backgroundColor, [Validators.required]],
      price30min: [this.price30min, [Validators.required]],
      price60min: [this.price60min, [Validators.required]],
      price90min: [this.price90min, [Validators.required]],
      price120min: [this.price120min, [Validators.required]],
      timeSlot: [this.timeSlot, [Validators.required]],
      ccy: [this.ccy, [Validators.required]],
      status: [this.status],
    }, { });
  }
  get f() { return this.simpleForm.controls; }


  async showSuccess(msg) {

    await this.toastr.success(msg, 'Success');

    if (this.isUpdate && !this.isError)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });;
      });  
    }
    else if (!this.isUpdate && this.isError == false)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });;
      });  
    }
  }

  showError(msg) {
    //this.toasterService.pop('error', 'Error', msg);
  }

  public showPayment()
  {
    //this.router.navigate(['facility'], {state: {data: ''}, relativeTo: this.route});
    // if (this.editFlag == true)
    // {
    //   this.editFlag = false;
    // }
    // if (this.editFlag == false)
    // {
    //   this.editFlag = true;
    // }
    // this.myDivRef.nativeElement.scrollIntoView({behavior: "smooth", block: "start" });
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.simpleForm.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
}


saveCourt = () => {
  return new Promise<any>(async (resolve, reject) => {
    this.isLoading = true;
    const fields = {
      courtId: this.mfData['id'],
      facilityId: this.facilityId,
      nameEn: this.f['nameEn'].value,
      nameAr: this.f['nameAr'].value,
      size: this.f['size'].value,
      noOfPlayers: this.f['noOfPlayers'].value,
      backgroundColor: this.f['backgroundColor'].value,
      price30min: this.f['price30min'].value,
      price60min: this.f['price60min'].value,
      price90min: this.f['price90min'].value,
      price120min: this.f['price120min'].value,
      timeSlot: this.f['timeSlot'].value,
      ccy: this.f['ccy'].value,
      status: this.f['status'].value,
    };
    if (this.isUpdate) 
    {
      this.localInterfaceSrv.updateCourt(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('Court Updated');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.desc, "Error");
      })
      .finally(() => this.isLoading = false);
    } 
    else 
    {
      this.localInterfaceSrv.addCourt(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('Court Added');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.desc, "Error");
      })
      .finally(() => this.isLoading = false);
    }
  });
}


  async delay(ms: number) {
    //await new Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>this.toolService.showConsoleLog("fired"));
}

  collapsed(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  updateData(name: string): void {
    this.updateData['nameEn'] = name;
  }
 

  expanded(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.iconCollapse = this.isCollapsed ? 'icon-arrow-down' : 'icon-arrow-up';
  }
  deleteCourt = (courtId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      const fields = {
        courtId: courtId
      };
      this.localInterfaceSrv.deleteCourt(courtId)
      .then(async res => {
        resolve(res);
        this.toastr.success("Court Removed", "Success");
        this.dangerModal.hide();
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
        });
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.desc, "Error");
        this.dangerModal.hide();
      })
      .finally(() => this.isLoading = false);
    });
  }
}
